import React from "react"

import BaseSvgIcon from "../Base"

const Store = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 -960 960 960">
      <path d="M160-720v-80h640v80zm0 560v-240h-40v-80l40-200h640l40 200v80h-40v240h-80v-240H560v240zm80-80h240v-160H240zm-38-240h556zm0 0h556l-24-120H226z" />
    </BaseSvgIcon>
  )
}

export default Store
